import get from 'lodash/get';
import has from 'lodash/has';
import pick from 'lodash/pick';

export const MFA_CHALLENGE_KEYS = ['mfaToken', 'enrollmentRequired', 'message', 'siteId'];

// Any sign-in response (200) or private-route refusal (403) that carries mfaRequired
export const isMfaChallengeResponse = (data) => !!get(data, 'mfaRequired');

export const mfaChallengeFromResponse = (data) => pick(data, MFA_CHALLENGE_KEYS);

// A 403 step-up keeps the session and only bites on private routes; a sign-in flow's challenge
// (no session yet) always goes to the code step. The 403 carries no challenge token: one already
// issued for the same site is kept, so repeated 403s never restart the code step.
export const mfaStepUpFromResponse = (data, previous) => {
  const stepUp = { ...mfaChallengeFromResponse(data), stepUp: true };
  const keepToken =
    get(previous, 'mfaToken') && !has(data, 'mfaToken') && (!previous.siteId || previous.siteId === stepUp.siteId);

  return keepToken ? { ...stepUp, mfaToken: previous.mfaToken } : stepUp;
};

// A step-up belongs to the site that refused the session; on any other site it is stale and must
// not show the banner or gate private routes. Kept while the site is still loading (no id yet).
export const mfaChallengeForSite = (challenge, siteId) =>
  challenge?.stepUp && siteId && challenge.siteId !== siteId ? null : challenge;
